import { Link, useNavigate, useParams } from "react-router-dom";

// https://github.com/DonAdam2/react-language-router-v6
const LinkLanguage = ({
  to,
  children,
  needNavigation = true,
  ...props
}: any) => {
  const { lang } = useParams();
  const language = lang === undefined ? "" : "/" + lang;
  const path = language + to;
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (props.action) {
      e.preventDefault(); // Sprečava automatsko navigiranje ako postoji `action`
      props.action();
      if (needNavigation) {
        navigate(path);
      }
    }
  };

  return (
    <Link
      to={path}
      className={props.className}
      style={props.style}
      onClick={handleClick}
      title={props.title}
    >
      {children}
    </Link>
  );
};
export default LinkLanguage;
